import * as React from 'react';

import { BargainTermsInfo } from './BargainTermsInfo';
import { CommercialInfo } from './CommercialInfo';
import { CommercialMultiAdsFactoids } from './CommercialMultiAdsFactoids';
import * as styles from './FavoriteInfo.css';
import { FlatInfo } from './FlatInfo';
import { JKInfo } from './JKInfo';
import { SuburbanInfo } from './SuburbanInfo';
import { MainTitleContainer } from '../../containers/MainTitle';
import { IFavoriteEntity } from '../../types/results';
import { getIsOfferWithMultiAds } from '../../utils/getIsOfferWithMultiAds';

export interface IFavoriteInfoProps {
  favoriteEntity: IFavoriteEntity;
}

export function FavoriteInfo({ favoriteEntity }: IFavoriteInfoProps) {
  const {
    fullUrl,
    title,
    flatInfo,
    suburbanInfo,
    jkInfo,
    commercialInfo,
    bargainTerms,
    entityId,
    isCianPartner,
    externalOfferUrl,
  } = favoriteEntity;
  const href = isCianPartner ? (externalOfferUrl as string) : fullUrl;

  const isCommercialMultiAds = getIsOfferWithMultiAds(commercialInfo);

  if (commercialInfo) {
    return (
      <div className={styles['base_info']}>
        <MainTitleContainer entityId={entityId} title={title} fullUrl={href} />
        {isCommercialMultiAds ? (
          <CommercialMultiAdsFactoids factoids={commercialInfo.factoids} />
        ) : (
          <CommercialInfo commercialInfo={commercialInfo} />
        )}
      </div>
    );
  }

  return (
    <>
      <div className={styles['base_info']}>
        <MainTitleContainer entityId={entityId} title={title} fullUrl={href} />
        {flatInfo && <FlatInfo flatInfo={flatInfo} />}
        {jkInfo && <JKInfo jkInfo={jkInfo} />}
        {suburbanInfo && <SuburbanInfo suburbanInfo={suburbanInfo} />}
      </div>
      <div className={styles['price_info']}>
        {bargainTerms && <BargainTermsInfo bargainTerms={bargainTerms} isNewbuilding={Boolean(jkInfo)} />}
      </div>
    </>
  );
}
